export default __webpack_public_path__ + "static/media/logo.f32b9649.png";